var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clientes"},[_c('monitor-clientes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }